import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { SidebarModule } from 'ng-sidebar';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { LayoutEmptyComponent } from './layouts/layout-empty/layout-empty.component';
import { LoginComponent } from './views/login/login.component';
import { ScSwitchComponent } from './components/ed-switch/ed-switch.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgSlimScrollModule, SLIMSCROLL_DEFAULTS } from 'ngx-slimscroll';
import { ScOnEnterDirective } from './directives/sc-on-enter.directive';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { SettingsComponent } from './views/settings/settings.component';
import { RegisterComponent } from './views/register/register.component';
import { ScAnchorLinkDirective } from './directives/sc-anchor-link.directive';
import { ScAnchorTargetDirective } from './directives/sc-anchor-target.directive';
import { FallbackSrcDirective } from './directives/fallback-src.directive';
import { ScfeUserCircleComponent } from './components/scfe-user-circle/scfe-user-circle.component';
import { HumanizedDatePipe } from './pipes/humanized-date.pipe';
import { HumanizedTimeSpanPipe } from './pipes/humanized-time-span.pipe';
import { ScFileIconDirective } from './directives/sc-file-icon.directive';
import { ScShowModalDirective } from './directives/sc-show-modal.directive';
import { HumanizedFileSizePipe } from './pipes/humanized-file-size.pipe';
import { ErrorComponent } from './views/error/error.component';
import { ScUserFirstNameDirective } from './directives/sc-user-first-name.directive';
import { ScUserLastNameDirective } from './directives/sc-user-last-name.directive';
import { ScUserInitialsDirective } from './directives/sc-user-initials.directive';
import { ScShowToggleDirective } from './directives/sc-show-toggle.directive';
import { TruncatePipe } from './pipes/truncate.pipe';
import { NavbarSideComponent } from './components/navbar-side/navbar-side.component';
import { LayoutSidenavigationComponent } from './layouts/layout-sidenavigation/layout-sidenavigation.component';
import { MarkdownModule } from 'ngx-markdown';
import { AlarmSettingsComponent } from './views/alarm-settings/alarm-settings.component';
import { AccessManagementComponent } from './views/access-management/access-management.component';
import { YesNoModalComponent } from './components/yes-no-modal/yes-no-modal.component';
import { PasswordResetComponent } from './views/password-reset/password-reset.component';
import { MonacoEditorModule } from 'ngx-monaco-editor';
import { registerLocaleData } from '@angular/common';
import localeDE from '@angular/common/locales/de';
import { DocumentationComponent } from './views/documentation/documentation.component';
import { EdBarChartComponent } from './components/ed-bar-chart/ed-bar-chart.component';
import { HumanizedMonthPipe } from './pipes/humanized-month.pipe';
import { HumanizedDayPipe } from './pipes/humanized-day.pipe';
import { ForceChangePasswordComponent } from './views/force-change-password/force-change-password.component';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HeaderComponent } from './components/header/header.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { RouterModule } from '@angular/router';
import { DateFormatPipe } from './pipes/dateformat.pipe';
import { DecimalDigitsPipe } from './pipes/decimal-digits-pipe';


registerLocaleData(localeDE);


const slimScrollSettings = {
  provide: SLIMSCROLL_DEFAULTS,
  useValue: {
    alwaysVisible: true,    
    gridBackground: 'rgba(44, 123, 229,.3)',
    gridWidth: '4',
    gridMargin: '2px 2px',
    barBackground: 'rgba(44, 123, 229,.6)',
    barWidth: '4',
    barMargin: '2px 2px'
  }
};

@NgModule({
  declarations: [
    AppComponent,
    LayoutEmptyComponent,
    LoginComponent,
    ScSwitchComponent,
    ScOnEnterDirective,
    DashboardComponent,
    SettingsComponent,
    RegisterComponent,
    ScAnchorLinkDirective,
    ScAnchorTargetDirective,
    FallbackSrcDirective,
    ScfeUserCircleComponent,
    HumanizedDatePipe,
    HumanizedTimeSpanPipe,
    ScFileIconDirective,
    ScShowModalDirective,
    HumanizedFileSizePipe,
    ErrorComponent,
    ScUserFirstNameDirective,
    ScUserLastNameDirective,
    ScUserInitialsDirective,
    ScShowToggleDirective,
    TruncatePipe,
    HeaderComponent,
    NavbarSideComponent,
    LayoutSidenavigationComponent,
    AlarmSettingsComponent,
    AccessManagementComponent,
    YesNoModalComponent,
    PasswordResetComponent,
    DocumentationComponent,
    EdBarChartComponent,
    HumanizedMonthPipe,
    HumanizedDayPipe,
    ForceChangePasswordComponent,
    DateFormatPipe,
    DecimalDigitsPipe
  ],
  imports: [
    BrowserModule,
    RouterModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule,
    SidebarModule.forRoot(),
    CommonModule,
    FormsModule,
     InfiniteScrollModule,
    NgSlimScrollModule,
    MarkdownModule.forRoot({ loader: HttpClient }),
    MonacoEditorModule.forRoot(),
    ToastModule,
    BrowserAnimationsModule,
    NgxDaterangepickerMd.forRoot()
  ],
  entryComponents: [
    
  ],
  providers: [
    slimScrollSettings,
    MessageService
  ],
  bootstrap: [AppComponent],
  exports: [
    
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { }
